import React from 'react';
import { CtaBlock } from '../CtaBlock';
export function Author() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-85" data-mp="1hrsk918qec7k">
      <div className="mx-auto max-w-3xl" data-id="element-86" data-mp="1hpo9bzcf0cxs">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-87" data-mp="1wh6zgpyznnuv">L’autrice</p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy sm:text-4xl" data-id="element-88" data-mp="1rpoza44shray">
          Dr.ssa Karito
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border border-navy/10 bg-white md:flex md:items-stretch" data-id="element-89" data-mp="25j6ghia06rxt">
          <img src="https://cdn.magicpatterns.com/uploads/8z3ABBVYpm4kN3RzjQYbox/Dra_Karito_real.png" alt="Dr.ssa Karito, creatrice del Sistema Maestro di Pianificazione con Allineatori" className="h-[300px] w-full object-cover object-top sm:h-[380px] md:h-auto md:w-[44%]" loading="lazy" data-id="element-90" data-mp="2ffjbcjhabbu5" />
          <div className="p-5 sm:p-7 md:w-[56%]" data-id="element-91" data-mp="g3qgothyyikl">
            <p className="text-[14.5px] font-semibold leading-relaxed text-navy" data-id="element-92" data-mp="3gemgrelnwuc1">
              Una biblioteca clinica pratica creata per professionisti che desiderano pianificare i casi con allineatori
              attraverso un processo più strutturato.
            </p>
            <p className="mt-3 text-[14px] leading-relaxed text-navy/65" data-id="element-93" data-mp="3pcy5fb2yxi1u">
              La Dr.ssa Karito ha sviluppato Il Sistema Maestro di Pianificazione con Allineatori™ partendo dalle
              domande che si pone prima di approvare ogni caso. Le stesse domande che possono fare la differenza tra un
              piano che appare semplicemente corretto sullo schermo e un piano affrontato con una vera struttura
              clinica.
            </p>
            <blockquote className="mt-5 border-l-4 border-brand pl-4" data-id="element-94" data-mp="gy6cg06ualje">
              <p className="font-display text-[15px] italic leading-relaxed text-navy" data-id="element-95" data-mp="2drrej06mjmwh">
                “L’obiettivo non è sostituire il tuo giudizio clinico. È offrirti un framework che ti aiuti a
                organizzarlo, affinché ogni decisione di pianificazione parta dalla chiarezza e non
                dall’incertezza.”
              </p>
              <footer className="mt-2 text-[12.5px] font-bold uppercase tracking-wide text-navy/50" data-id="element-96" data-mp="3h3zur2hmd2kx">
                Dr.ssa Karito
              </footer>
            </blockquote>
          </div>
        </div>

        <CtaBlock className="mt-9" label="Accedi al Sistema della Dr.ssa Karito" data-id="element-97" data-mp="3q1s8413s605o" />
      </div>
    </section>;
}